import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";
import ContacteventifyModal from "./contact-modal";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class BillingDetailsHeader extends Component {

  constructor(props) {
    super(props);

    this.state = {
        loading: false,
        isOpen: false,
    };
  }

  componentDidMount() {

  }

  openModal = (section) => {
    this.setState({
      isOpen: true,
    });
  };
  closeModal = () => {
    this.setState({ isOpen: false });
  };

  //Arrow function for renderLoader

  render() {
    let{total_accountusageCount,user,clientdataforbilling} = this.props;
    let userlimit=0;
    let accountusage= 0;
    let invalid = false;
    let exceededby = 0;
    // console.log('clientdataforbilling',clientdataforbilling)
    if(total_accountusageCount && clientdataforbilling && clientdataforbilling.length > 0){
      // console.log('user',user)
      userlimit = clientdataforbilling[0].userlimit;
      accountusage=total_accountusageCount.count;
      exceededby = parseInt(userlimit) - parseInt(total_accountusageCount.count);
      if(parseInt(accountusage) > parseInt(userlimit)){
        invalid = true;
      }
    }

    return (
        <div className="panel-header">
          <div className="pull-left h-100 vertical-align-center">
            <div className="">
              <div className="custom-text1-primary-medium">
                {/* {LocaleStrings.accountsetting_billingdetails_headerleft} */}
                <div className="custom-text2-secondary-normal">Billing details for - <span style={{color:'#105efb'}}>{this.props.user.email}</span></div>
              </div>
              {invalid == true ? (
                <div className="custom-text1-primary-medium text-danger">
                {LocaleStrings.accountsetting_billingdetails_headerleftuserlimitexceeded} {exceededby}
              </div>
              ):('')}
              
            </div>
          </div>
          {/* <div className="pull-right h-100 vertical-align-center">
            <Button
              bsStyle=""
              className="btn-custom-blue"
              onClick={() => this.openModal()}
            >
              {LocaleStrings.accountsetting_billingdetails_headerright_contactbuttion}
            </Button>
            {this.state.isOpen ? (
              <ContacteventifyModal
                isOpen={this.state.isOpen}
                onClose={this.closeModal}
              />
            ) : (
              ""
            )}
          </div> */}
        </div>
    );
  }
}


function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    total_accountusageCount:state.total_accountusageCount,
    clientdataforbilling:state.clientdataforbilling
  };
}

export default connect(mapStateToProps, {})(BillingDetailsHeader);
